import React, { useEffect, useState } from "react"
import { useRouter } from "next/router"
import PropTypes from "prop-types"
import Typed from "react-typed"
import {
  TextSM,
  Box,
  Stack,
  HeadingFour,
  Spinner,
  Text,
} from "datastory-shared/ui"
import { Section, PageHeader } from "datastory-shared/sections"

import Parliament from "./Parliament"

import { fetchData } from "utils/api/clients/hypothetical-riksdag-sweden"

const HypoRiksdagSweden = () => {
  const [data, setData] = useState({})
  const { locale } = useRouter()

  useEffect(() => {
    const fetchServiceData = async () => {
      const data = await fetchData(locale)
      setData(data)
    }
    fetchServiceData()
  }, [locale])

  const { mainData, indicators } = data

  return (
    <>
      <PageHeader
        title={
          <>
            {"Riksdagen om bara "} <br />
            <TextSM as="span" color="primary.500" fontSize="inherit">
              <Typed
                strings={[
                  "kvinnor",
                  "män",
                  "gamla",
                  "unga",
                  "stockholmare",
                  "skåningar",
                  "kvinnor",
                ]}
                data
                typeSpeed={100}
                startDelay={2500}
                backDelay={1500}
                backSpeed={70}
              >
                <span>{"kvinnor"}</span>
              </Typed>
            </TextSM>
            {" röstade"}
          </>
        }
        lead={
          <Box display={["none", "block"]}>
            {
              "Höginkomsttagare röstar blått, och LO-medlemmar rött. Eller? Med data från SCB* kan du själv testa hur riksdagen skulle kunna se ut om en viss grupp fick bestämma."
            }
          </Box>
        }
        sublead={
          "* Bygger på skattningen av partisympatier i väljarkåren från SCB."
        }
      />

      <Section maxW="container.sm">
        {mainData ? (
          <Parliament
            data={mainData}
            indicators={indicators}
            exampleIndicators={[
              {
                name: "Kvinnor",
                id: "og:og:date_og:sex_og:politicalParty_og:female",
              },
              {
                name: "Män",
                id: "og:og:date_og:sex_og:politicalParty_og:male",
              },
              {
                name: "Norrlänningar",
                id: "og:og:date_og:politicalParty_og:psuRegion_og:psu-reg-north",
              },
              {
                name: "Stockholmare",
                id: "og:og:date_og:politicalParty_og:psuRegion_og:psu-reg-sthlm",
              },
              {
                name: "Ej sysselsatta",
                id: "og:og:date_og:employmentStatus_og:politicalParty_og:unemployed",
              },
            ]}
            withLabels
            withSlider
            withSeatCount
          />
        ) : (
          <Box mx="auto" width="300px" textAlign="center">
            <Spinner />
            <TextSM>{"Laddar visualisering…"}</TextSM>
          </Box>
        )}
      </Section>

      <Section size="container.sm" data-cy="section-method">
        <Stack spacing="md">
          <HeadingFour>{"Metod och källor"}</HeadingFour>
          <Text>
            {
              "SCB genomför partisympatiundersökningen två gånger om året. Undersökningen visar i vilka demografiska grupper de olika partierna har sitt starkaste stöd. Partisympati avser ingen specifik nivå i politiken och ingen hänsyn tas till om man skulle rösta eller inte."
            }
          </Text>
          <Text>
            {
              'Frågan som ställts är: "Är det något av de politiska partierna som står dig närmare än de andra?" Om inget svar ges så ställs frågan: "Men vilket parti har du störst sympati för?" Dessa frågor ska inte blandas ihop med den närliggande frågan om vilket parti man skulle rösta på om det vore riksdagsval någon av de närmaste dagarna.'
            }
          </Text>
          <Text>
            {
              "Vi beräknar mandatfördelningen med samma metod som Valmyndigheten använder vid det faktiska riksdagsvalet, den så kallade jämkade uddatalsmetoden."
            }
          </Text>
          <Text>
            {
              "Ö står för övriga partier. Vi har valt att tilldela mandat för övriga partier om de sammantaget får över 4%. På senare år har övriga i SCB:s partisympatiundersökning framförallt utgjorts av Feministiskt initiativ."
            }
          </Text>
        </Stack>
      </Section>
    </>
  )
}

HypoRiksdagSweden.propTypes = {
  data: PropTypes.object,
}

export default HypoRiksdagSweden
